import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const Container = styled(FlexRow)`
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
`;
export const GreyCaptionText = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    ${setFontVariant("caption", carbon[300])}
`;

export const PercentValue = styled.span`
    ${setFontVariant("captionTitle", carbon[500])}
`;
